import { ArrowLeftOutlined, CheckOutlined } from "@ant-design/icons";
import { CHECKOUT_STEP_2 } from "constants/routes";
import { useFormikContext } from "formik";
import { displayMoney } from "helpers/utils";
import PropType from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setPaymentDetails } from "redux/actions/checkoutActions";

const Total = ({ isInternational, subtotal }) => {
  const { values, submitForm } = useFormikContext();
  const history = useHistory();
  const dispatch = useDispatch();

  const disableOnClick = (event) => {
    event.currentTarget.disabled = true;
    submitForm();
  };

  const onClickBack = () => {
    // destructure to only select left fields omitting cardnumber and ccv
    const { cardnumber, ccv, ...rest } = values;

    dispatch(setPaymentDetails({ ...rest })); // save payment details
    history.push(CHECKOUT_STEP_2);
  };

  return (
    <>
      <div className="basket-total text-right">
        {/* <p className="basket-total-title">Subtotal: <del>{displayMoney(subtotal)}</del>
        &nbsp;{displayMoney((subtotal/2).toFixed())}</p>
        <p className="basket-total-title">Shipping Fee:  {displayMoney(50)}</p> */}
        <p className="basket-total-title">
          Subtotal: {displayMoney(subtotal + 50)}
        </p>
        <p className="basket-total-title">Shipping Fee: {displayMoney(50)}</p>

        {/* <h2 className="basket-total-amount">

      {displayMoney(subtotal + (isInternational ? 50 : 0))}


        </h2> */}

        <h2 className="basket-total-amount">
          Total: {displayMoney(subtotal + 50)}
          {/* {displayMoney(((subtotal/2) + 50).toFixed())} */}
        </h2>

        {/* <h2 className="basket-total-amount">
          {displayMoney((subtotal/2).toFixed())}<br/>List Price:<del> &nbsp;{displayMoney(subtotal)}</del>

        </h2> */}
      </div>
      <br />
      <div className="checkout-shipping-action">
        <button
          className="button button-muted"
          onClick={() => onClickBack(values)}
          type="button"
        >
          <ArrowLeftOutlined />
          &nbsp; Go Back
        </button>
        <button
          className="button"
          disabled={false}
          onClick={disableOnClick}
          type="button"
        >
          <CheckOutlined />
          &nbsp; Confirm
        </button>
      </div>
    </>
  );
};

Total.propTypes = {
  isInternational: PropType.bool.isRequired,
  subtotal: PropType.number.isRequired,
};

export default Total;
